import { render, staticRenderFns } from "./PlansLegacy.vue?vue&type=template&id=40b71e8e&scoped=true"
import script from "./PlansLegacy.vue?vue&type=script&lang=js"
export * from "./PlansLegacy.vue?vue&type=script&lang=js"
import style0 from "./PlansLegacy.vue?vue&type=style&index=0&id=40b71e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b71e8e",
  null
  
)

export default component.exports